import { Navigate, useLocation } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import AddPostForm from '@/shared-components/forms/add-board-content/add-post';
import { canAccessGalleryPermission } from '@/utils/galleryPermissions';

export default function AddPost() {
  const location = useLocation();
  const { state } = useStateHandler();
  const session = state.user_session;
  const canCreatePost = !session?.gallery_id
    || canAccessGalleryPermission(session, "board.post", session?.gallery_id);

  if (!canCreatePost) {
    return <Navigate to="/profile/board" replace />;
  }

  return (
    <>
      <AddPostForm
        postData={location.state?.draftData}
      />
    </>
  );
}
